import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FormLS_UB_2 from "../../Forms/FormLS_UB_2";
import Footer from "../../Includes/Layouts/LS_UB_2/Footer";
import FbViewPixel from "../../../Utility/FbViewPixel";
import "../../../assets/LS_UB_2/css/LS_UB_2.scss";
import Header from "../../Includes/Layouts/LS_UB_2/Header";
import Section1 from "../../Includes/Layouts/LS_UB_2/Section1";
import AccordSection from "../../Includes/Layouts/LS_UB_2/AccordSection";

const LS_UB_2 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="LS_UB_2" />
      <FbViewPixel />
      <div className="LS_UB_2">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormLS_UB_2 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default LS_UB_2;